import api from '../../plugins/api';

// GET /crm/cars/findByVin?query= — машины, у которых VIN содержит введённые знаки (от 5).
// Ответ: [{ id, vin, mark, model, issueYear, color, price, used }], лучшие совпадения первыми.
const findByVin = (query) => {
  return api.get('/api/crm/cars/findByVin', { query });
};

export default findByVin;
